/**
 * 基础菜单 商品管理
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home/Home' }">Home</el-breadcrumb-item>
      <el-breadcrumb-item>{{ childMsg.breadcrumb }}</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="Search：">
        <el-input size="small" v-model="formInline.softwareSerialNumber" :placeholder="childMsg.data[1].label"></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-input size="small" v-model="formInline.machineName" :placeholder="childMsg.data[2].label"></el-input>
      </el-form-item>
      <!-- 患者列表显示 -->
      <el-form-item v-show="childMsg.dbName === 'patient'" label="">
        <el-input size="small" v-model="formInline.tel" :placeholder="childMsg.data[4].label"></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-select size="small" clearable v-model="formInline.belongingText" :placeholder="childMsg.data[3].label">
          <el-option v-for="(item,i) in belongingOptions" :key="i" :label="item.companyName" :value="item.companyName"></el-option>
        </el-select>
      </el-form-item>
      <!-- 患者列表 不需要显示 -->
      <el-form-item label="" v-show="childMsg.dbName !== 'patient'">
        <el-select size="small" clearable v-model="formInline.assignBelongingText" :placeholder="childMsg.data[3].title">
          <el-option v-for="(item,i) in childMsg.assignBelonging" :key="i" :label="item" :value="item"></el-option>
        </el-select>
      </el-form-item>
      <!-- 患者列表 不需要显示 -->
      <el-form-item label="" v-show="childMsg.dbName !== 'patient'">
        <el-select size="small" clearable v-model="formInline.statusText" :placeholder="childMsg.data[(childMsg.data.length-2)].label">
          <el-option v-for="(item,i) in childMsg.statusArr" :key="i" :label="item" :value="item"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="Creation Time">
        <el-date-picker size="small" v-model="formInline.creationTime" type="daterange" align="right" unlink-panels range-separator="To" start-placeholder="Start Date" end-placeholder="Ending Date" :picker-options="pickerOptions"></el-date-picker>
      </el-form-item>
      <!-- 报警信息 患者列表 不需要显示 -->
      <!-- <el-form-item v-show="childMsg.bool" label="Last Online Time">
        <el-date-picker size="small" v-model="formInline.lastOnlineTime" type="daterange" align="right" unlink-panels range-separator="To" start-placeholder="Start Date" end-placeholder="Ending Date" :picker-options="pickerOptions"></el-date-picker>
      </el-form-item> -->
      <!-- 患者列表显示 -->
      <el-form-item v-show="childMsg.dbName === 'patient'" label="Last Treatment Time">
        <el-date-picker size="small" v-model="formInline.lastOnlineTime" type="daterange" align="right" unlink-panels range-separator="To" start-placeholder="Start Date" end-placeholder="Ending Date" :picker-options="pickerOptions"></el-date-picker>
      </el-form-item>
      <el-form-item label="">
        <el-date-picker v-show="childMsg.bool" placeholder="Expiration Date" size="small" v-model="formInline.rentalTime" type="date"></el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">Search</el-button>
        <el-button v-show="childMsg.dbName !== 'alarm' && childMsg.dbName !== 'patient'" size="small" type="primary" icon="el-icon-plus" @click="handleEdit()">Assign Beauty Center</el-button>
        <el-button v-show="childMsg.dbName !== 'alarm' && childMsg.dbName !== 'patient'" size="small" type="primary" icon="el-icon-plus" @click="AddMachine()">Add Machine</el-button>
        <el-button v-show="childMsg.dbName === 'patient'" size="small" type="primary" icon="el-icon-plus" @click="userForm()">Add User</el-button>
      </el-form-item>
    </el-form>
    <!-- 列表 此表在报警或故障列表不显示 -->
    <el-table v-show="childMsg.dbName !== 'alarm'" :default-sort = "{prop: 'creationTime', order: 'descending'}" ref="multipleTable" size="small" :data="listData" highlight-current-row v-loading="loading" @selection-change="handleSelectionChange" border element-loading-text="loading..." style="width: 100%;">
      <el-table-column :type="childMsg.type" width="40"></el-table-column>
      <el-table-column v-for="item in childMsg.data" align="center" :prop="item.prop" :label="item.label" :width="childMsg.dbName === 'patient'?'240':'72'"></el-table-column>
      <el-table-column align="center" fixed="right" label="Operation" :width="childMsg.dbName === 'machine'?'440':'300'">
        <template slot-scope="scope">
          <el-button v-show="childMsg.dbName !== 'patient'" size="mini" @click="handleEdit(scope.$index, scope.row)">Edit</el-button>
          <router-link v-show="childMsg.dbName !== 'patient'" :to="'/realTime?SN=' + scope.row.serialNumber">
            <el-button size="mini" type="primary">Real Time</el-button>
          </router-link>
          <!-- 患者列表不显示 -->
          <el-button v-show="childMsg.dbName !== 'patient'" size="mini" type="warning" @click="checkMap(scope.$index, scope.row)">Map</el-button>
          <el-button v-show="childMsg.dbName !== 'patient'" v-if="accountUser == 'admin'" size="mini" type="info" @click="Update(scope.$index, scope.row)">Update Version</el-button>
          <el-button v-show="childMsg.dbName !== 'patient'" size="mini" :type="scope.row.status === 'disable'?'success':'danger'" @click="deleteUser(scope.$index, scope.row)">{{scope.row.status === 'disable'?'Enable':'Disable'}}</el-button>
          <!-- 患者列表显示 -->
          <!-- <el-button v-show="childMsg.dbName === 'patient'" size="mini" type="success" @click="modifyParameters(scope.$index, scope.row)">Parameters Setting</el-button> -->
          <el-button v-show="childMsg.dbName === 'patient'" size="mini" type="warning" @click="checkHistory(scope.$index, scope.row)">Treatment Log</el-button>
          <el-button v-show="childMsg.dbName === 'patient'" size="mini" type="danger" @click="deletePatientBtn(scope.$index, scope.row)">Delete</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 报警或故障信息显示的列表 -->
    <el-table v-show="childMsg.dbName === 'alarm'" :default-sort = "{prop: 'creationTime', order: 'descending'}" ref="multipleTable" size="small" :data="listData" highlight-current-row v-loading="loading" @selection-change="handleSelectionChange" border element-loading-text="loading..." style="width: 100%;">
      <el-table-column fixed="left" :type="childMsg.type" width="40"></el-table-column>
      <el-table-column v-for="item in childMsg.data" align="center" :prop="item.prop" :label="item.label" width="222"></el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- 编辑界面 -->
    <el-drawer :title="title" size="40%" :before-close="handleClose" :visible.sync="dialog" direction="ltr" custom-class="demo-drawer" ref="drawer">
      <div class="demo-drawer__content">
        <el-form :model="formInline">
          <el-form-item v-show="childMsg.serialNumberBool === false && title !== 'Add Machine'" :label="childMsg.dbName === 'patient'?'User Name:':'MCU S/N:'" label-width="120px" border>
            <div class='serialnNmber-tag'>
              <el-tag v-for="(item,i) in formInline.serialNumberArr" :key="i" closable type="info" size="small" :disable-transitions="false" @close="tagClose(i)"> {{item.serialNumber?item.serialNumber:(item.firstName + ' ' + item.lastName)}} </el-tag>
            </div>
          </el-form-item>
          <el-form-item v-show="title === 'Add Machine'" label="MCU S/N:" label-width="180px" border>
            <el-input v-model="formInline.softwareSerialNumber"></el-input>
          </el-form-item>
          <el-form-item v-show="title === 'Add Machine'" label="Machine S/N:" label-width="180px" border>
            <el-input v-model="formInline.serialNumber"></el-input>
          </el-form-item>
          <el-form-item v-show="childMsg.serialNumberBool !== false" label="MCU S/N:" label-width="180px" border>
            <el-input v-model="formInline.serialNumber" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item v-show="childMsg.serialNumberBool !== false" label="Machine S/N:" label-width="180px" border>
            <el-input v-model="softwareSerialNumber"></el-input>
          </el-form-item>
          <el-form-item v-show="childMsg.serialNumberBool !== false" label="Machine Name:" label-width="180px" border>
            <el-input v-model="formInline.machineName"></el-input>
          </el-form-item>
          <el-form-item v-show="childMsg.dbName === 'patient'" label="User Name:" label-width="180px" border>
            <el-input v-model="formInline.userName" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item label="Beauty center:" label-width="180px">
            <el-select v-model="formInline.belongingText" placeholder="Beauty center">
              <el-option v-for="item in belongingOptions" :key="item.companyName" :label="item.companyName" :value="item.companyName"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Expiration Date:" v-show="childMsg.dbName === 'machine'"  label-width="180px">
            <el-date-picker placeholder="Date" size="small" v-model="formInline.rentalTime" type="date"></el-date-picker>
          </el-form-item>
        </el-form>
        <div class="demo-drawer__footer">
          <el-button @click="cancelForm">Cancel</el-button>
          <el-button type="primary" @click="submitForm" :loading="loading">{{ loading ? 'Loading ...' : 'Confirm' }}</el-button>
        </div>
      </div>
    </el-drawer>
    <!-- 地图 -->
    <el-dialog :visible.sync="mapFormVisible" width="60%" @click="closeDialog">
      <div style = 'height:400px'>
        <Map></Map>
      </div>
    </el-dialog>
    <!-- 版本更新 -->
    <el-dialog :visible.sync="updateFormVisible" width="20%" @click="closeDialog">
      <el-select v-model="versionType" placeholder="Please Select">
        <el-option v-for="item in versionList" :key="item.version" :label="item.version" :value="item.version">
        </el-option>
      </el-select>
      <span slot="footer" class="dialog-footer">
        <el-button size='small' @click="updateFormVisible = false">Cancel</el-button>
        <el-button size='small' type="primary" :loading="loading" @click="saveVersionData">Confirm</el-button>
      </span>
    </el-dialog>
    <!-- 查看诊疗计划 -->
    <el-dialog :title="title" :visible.sync="historyFormVisible" width="60%" @click="closeDialog">
      <!-- <el-steps :active="active" finish-status="wait">
        <el-step title="Processing"></el-step>
        <el-step title="Finished"></el-step>
        <el-step title="Newly add "></el-step>
      </el-steps> -->
      <el-button style="margin-top: 12px;" @click="next(0)">In Treatment</el-button>
      <el-button style="margin-top: 12px;" @click="next(1)">Treatment History</el-button>
      <el-button style="margin-top: 12px;" @click="next(2)">New Treatment List</el-button>
      <el-button style="margin-top: 12px;" @click="next(3)">New Treatment </el-button>
      <el-table v-if="active != 3" size="small" :default-sort = "{prop: 'creationTime', order: 'ascending'}" :data="planList" highlight-current-row v-loading="loading" border element-loading-text="Loading..." style="width: 100%;">
        <el-table-column align="center" type="index" width="30"></el-table-column>
        <el-table-column align="center" prop="fromMachine" label="Serial Number" width="120"></el-table-column>
        <el-table-column align="center" prop="mode" label="Treatment Type" width="120"></el-table-column>
          <!-- <template slot-scope="scope">
            <div>{{scope.row.editTime|timestampToTime}}</div>
          </template> -->
        <!-- </el-table-column> -->
        <el-table-column align="center" prop="skinType" label="Skin Type" width="120"></el-table-column>
        <el-table-column align="center" prop="fluence" label="Fluence" width="120"></el-table-column>
        <el-table-column align="center" prop="pulse" label="Pulse" width="120"></el-table-column>
        <el-table-column align="center" prop="frequency" label="Frequency" width="120"></el-table-column>
        <el-table-column align="center" prop="cooling" label="Cooling" width="120"></el-table-column>
        <el-table-column v-if="active != 2" align="center" prop="counter" label="Shots" width="120"></el-table-column>
        <el-table-column align="center" prop="creationTime" label="creationTime" width="120"></el-table-column>
      </el-table>
      <!-- 诊疗计划 -->

      <el-form v-if="active == 3" id='userFormVisible' ref="editForm" :model="rulesPlanForm" :rules="rules">
        <div id="realTime-bg">
          <img :src="pararm_imgsrc" width="100%" />
          <div v-show="showMenuBtn" class="menu_btn">
            <span class="hrm_btn" @click="showHrmSkin"></span>
            <span class="hrs_btn" @click="showHrs"></span>
            <span class="stm_btn" @click="showStm"></span>
          </div>
          <div v-show="showHrmMenu" class="hrm_menu">
            <div :class="upClass" @click="up"></div>
            <div :class="downClass" @click="down"></div>
            <div :class="backClass" @click="back('HRM')"></div>
            <p v-show="pararm_showFluence" :class="pararm_fluenceClass">{{pararm_fluence}}</p>
            <div :class="confirmClass" @click="saveChang"></div>
          </div>
          <div v-show="showHrsMenu" class="hrs_menu">
            <div :class="upClass" @click="up"></div>
            <div :class="downClass" @click="down"></div>
            <div :class="backClass" @click="back('HRS')"></div>
            <p v-show="pararm_showFluence" :class="pararm_fluenceClass" @click="changContent('fluence')">{{pararm_fluence}}</p>
            <p v-show="pararm_showPulse" :class="pararm_pulseClass" @click="changContent('pulse')">{{pararm_pulse}}</p>
            <p v-show="pararm_showFrequency" :class="pararm_frequencyClass" @click="changContent('frequency')">{{pararm_frequency}}</p>
            <p v-show="pararm_showCooling" :class="pararm_coolingClass" @click="changContent('cooling')">{{pararm_cooling}}</p>
            <div :class="confirmClass" @click="saveChang"></div>
          </div>
          <div v-show="showSrsmMenu">
            <div :class="upClass" @click="up"></div>
            <div :class="downClass" @click="down"></div>
            <div class="srsm_skinType">
              <div class="type6" @click="clickType('6',$event)"></div>
              <div class="type5" @click="clickType('5',$event)"></div>
              <div class="type4" @click="clickType('4',$event)"></div>
              <div class="type3" @click="clickType('3',$event)"></div>
              <div class="type2" @click="clickType('2',$event)"></div>
              <div class="type1" @click="clickType('1',$event)"></div>
            </div>
            <p v-show="pararm_showFluence" :class="pararm_fluenceClass" @click="changContent('fluence')">{{pararm_fluence}}</p>
            <p v-show="pararm_showPulse" :class="pararm_pulseClass" @click="changContent('pulse')">{{pararm_pulse}}</p>
            <p v-show="pararm_showFrequency" :class="pararm_frequencyClass" @click="changContent('frequency')">{{pararm_frequency}}</p>
            <div :class="confirmClass" @click="saveChang"></div>
            <div :class="backClass" @click="back('SRSM')"></div>
          </div>
          <div v-show="showSrmmMenu">
            <div :class="upClass" @click="up"></div>
            <div :class="downClass" @click="down"></div>
            <div class="srmm_skinType">
              <div class="type6" @click="clickType('6',$event)"></div>
              <div class="type5" @click="clickType('5',$event)"></div>
              <div class="type4" @click="clickType('4',$event)"></div>
              <div class="type3" @click="clickType('3',$event)"></div>
              <div class="type2" @click="clickType('2',$event)"></div>
              <div class="type1" @click="clickType('1',$event)"></div>
            </div>
            <p v-show="pararm_showFluence" :class="pararm_fluenceClass" @click="changContent('fluence')">{{pararm_fluence}}</p>
            <p v-show="pararm_showPulse" :class="pararm_pulseClass" @click="changContent('pulse')">{{pararm_pulse}}</p>
            <p v-show="pararm_showFrequency" :class="pararm_frequencyClass" @click="changContent('frequency')">{{pararm_frequency}}</p>
            <div :class="confirmClass" @click="saveChang"></div>
            <div :class="backClass" @click="back('SRMM')"></div>
          </div>
          <div v-show="showStmMenu" class='stm_menu'>
            <div class="srsm_menu" @click="showSrsm"></div>
            <div class="srmm_menu" @click="showSrmm"></div>
            <div :class="backClass" @click="back('STM')"></div>
          </div>
          <div v-show="showHrmSkinMenu" class='hrmSkin_menu'>
            <div class="hrmSkin_option" @click="showHrm('1')"></div>
            <div class="hrmSkin_option" @click="showHrm('2')"></div>
            <div class="hrmSkin_option" @click="showHrm('3')"></div>
            <div class="hrmSkin_option" @click="showHrm('4')"></div>
            <div class="hrmSkin_option" @click="showHrm('5')"></div>
            <div class="hrmSkin_option" @click="showHrm('6')"></div>
            <div :class="backClass" @click="back('SKIN')"></div>
          </div>
        </div>
        <el-form-item label-width="100px" label="Description" prop="description">
          <el-input size="small" v-model="rulesPlanForm.description" auto-complete="off" placeholder="Please enter your description"></el-input>
        </el-form-item>
        <el-form-item label-width="100px" label="Date" prop="date">
          <el-date-picker
            v-model="rulesPlanForm.date"
            type="date"
            size="small"
            placeholder="Please enter your date">
          </el-date-picker>
        </el-form-item>
      </el-form>
      <!-- <el-form v-if="active == 3" id='userFormVisible' ref="editForm" :model="rulesPlanForm" :rules="rules">
        <el-form-item label-width="120px" label="Treatment Type" prop="type">
          <el-input size="small" v-model="rulesPlanForm.type" auto-complete="off" placeholder="Please enter your treatment type"></el-input>
        </el-form-item>
        <el-form-item label-width="100px" label="Description" prop="description">
          <el-input size="small" v-model="rulesPlanForm.description" auto-complete="off" placeholder="Please enter your description"></el-input>
        </el-form-item>
        <el-form-item label-width="100px" label="Date" prop="date">
          <el-date-picker
            v-model="rulesPlanForm.date"
            type="date"
            size="small"
            placeholder="Please enter your date">
          </el-date-picker>
        </el-form-item>
      </el-form> -->
      <div v-if="active == 3" class="demo-drawer__footer">
        <el-button type="primary" @click="saveUserEditForm('add')" :loading="loading">Save</el-button>
      </div>
    </el-dialog>
    <!-- 新增患者 -->
    <el-dialog :title="title" :visible.sync="userFormVisible" @click="closeDialog">
      <el-form id='userFormVisible' ref="editForm" :model="userEditForm" :rules="rules">
        <el-form-item label-width="100px" label="First Name" prop="firstName">
          <el-input size="small" v-model="userEditForm.firstName" auto-complete="off" placeholder="Please enter your firstname"></el-input>
        </el-form-item>
        <el-form-item label-width="100px" label="Last Name" prop="lastName">
          <el-input size="small" v-model="userEditForm.lastName" auto-complete="off" placeholder="Please enter your lastname"></el-input>
        </el-form-item>
        <el-form-item label-width="100px" label="Gender" prop="sex">
          <el-input size="small" v-model="userEditForm.sex" auto-complete="off" placeholder="Please enter your gender"></el-input>
        </el-form-item>
        <el-form-item label-width="100px" label="Tel." prop="tel">
          <el-input size="small" v-model="userEditForm.tel" auto-complete="off" placeholder="Please enter your phone"></el-input>
        </el-form-item>
      </el-form>
      <!-- 诊疗计划 -->
      <!-- <el-form v-if="showPlan" id='userFormVisible' ref="editForm" :model="rulesPlanForm" :rules="rules">
        <el-form-item label-width="120px" label="Treatment Type" prop="type">
          <el-input size="small" v-model="rulesPlanForm.type" auto-complete="off" placeholder="Please enter your treatment type"></el-input>
        </el-form-item>
        <el-form-item label-width="100px" label="Description" prop="description">
          <el-input size="small" v-model="rulesPlanForm.description" auto-complete="off" placeholder="Please enter your description"></el-input>
        </el-form-item>
        <el-form-item label-width="100px" label="Date" prop="date">
          <el-date-picker
            v-model="rulesPlanForm.date"
            type="date"
            size="small"
            placeholder="Please enter your date">
          </el-date-picker>
        </el-form-item>
      </el-form>
      <div class="add_plan">
        <el-button v-show="childMsg.dbName === 'patient'" size="mini" type="primary" @click="addPlan">{{showPlan?'close Scheduled Session':'Add Scheduled Session'}}</el-button>
      </div> -->
      <div class="demo-drawer__footer">
        <el-button type="primary" @click="saveUserEditForm('new')" :loading="loading">Save</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  dataList,
  deptSave,
  deptDelete,
  userList,
  getHistory,
  createPatient,
  createScheduledSession,
  deletePatient,
  getPatientData,
  getbeautyCenter,
  updatebeautyCenter,
  getVersion,
  updateMachineVersion,
  disableMachine,
  getMachineData,
  saveMachine
 } from '../api/userMG'
import Pagination from './Pagination'
import Map from '@/components/Map'
export default {
  name: 'DataList',
  props: ['childMsg'],
  data() {
    return {
      accountUser: JSON.parse(localStorage.getItem('userdata'))._source.account,
      loading:false,
      scrollDisabled: false,
      parametersFormVisible: false,
      changFormVisible: false,
      fluenceFormVisible: false,
      frequencyFormVisible: false,
      pulseFormVisible: false,
      coolingFormVisible: false,
      fluenceClass: 'fluence',
      pulseClass: 'pulse',
      frequencyClass: 'frequency',
      coolingClass: 'cooling',
      upClass: '',
      downClass: '',
      backClass: '',
      confirmClass: '',
      showFluence: false,
      showPulse: false,
      showFrequency: false,
      showCooling: false,
      showMenuBtn: true,
      showHrmMenu: false,
      showHrsMenu: false,
      showSrsmMenu: false,
      showSrmmMenu: false,
      showHrmSkinMenu: false,
      showStmMenu: false,
      pararm_showFluence: false,
      pararm_showPulse: false,
      pararm_showFrequency: false,
      pararm_showCooling: false,
      pararm_option: null,
      pararm_mode: '',
      pararm_skinType: '0',
      pararm_fluence: 5,
      pararm_pulse: 30,
      pararm_frequency: 1,
      pararm_cooling: 0,
      pararm_fluenceClass: 'pararm_fluence',
      pararm_pulseClass: 'pararm_pulse',
      pararm_frequencyClass: 'pararm_frequency',
      pararm_coolingClass: 'pararm_cooling',
      imgsrc: require('../assets/img/zhujiemian.jpg'),
      pararm_imgsrc: require('../assets/img/zhujiemian.jpg'),
      changParmNum: '',
      changStep: 1,
      num: 1,
      fluenceMin: 0,
      fluenceMax: 100,
      frequencyMin: 0,
      frequencyMax: 10,
      status: null,
      editNow: false,
      mode: 'HRS',
      fluence: {title: 'fluence',num: 0},
      pulse: {title: 'pulse',num: 0},
      frequency: {title: 'frequency',num: 0},
      cooling: {title: 'cooling',num: 0},
      skinType: ['face-color-1', 'face-color-2', 'face-color-3', 'face-color-4', 'face-color-5', 'face-color-6'],
      timer: null,
      loginUser: JSON.parse(localStorage.getItem('userdata'))._source.authority,
      softwareSerialNumber: '',
      rulesPlanForm: {},
      showPlan: false,
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      historyFormVisible: false,
      userFormVisible: false,
      parametersFormVisible: false,
      mapFormVisible: false,
      updateFormVisible: false,
      versionType: '',
      title: 'Add',
      table: false,
      dialog: false,
      active: 0,
      planList: [],
      belongingOptions: [],
      pickerOptions: {
        shortcuts: [{
          text: 'Latest week',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Last month',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      editForm: {
        serialNumber: '',
        belonging: '',
        rentalTime: ''
      },
      userEditForm:{
        firstName: '',
        lastName: '',
        sex: '',
        tel: '',
        totalCnt: '',
        belonging: '',
        attribution: '',
        lastUsedMachine: '',
        creationTime: '',
        lastTreatmentTime: ''
      },
      versionEditForm: {},
      // rules表单验证
      rules: {
        deptNo: [{ required: true, message: 'Please bind to belonging!', trigger: 'blur' }],
        firstName: [
          { required: true, message: 'Please enter your First Name', trigger: 'blur' }
        ],
        lastName: [{ required: true, message: 'Please enter your Last Name', trigger: 'blur' }],
        tel: [{ required: true, message: 'Please enter your phone', trigger: 'blur' }],
        type: [
          { required: true, message: 'Please enter your treatment type', trigger: 'blur' }
        ],
        description: [{ required: true, message: 'Please enter your description', trigger: 'blur' }],
        date: [{ required: true, message: 'Please enter your date', trigger: 'blur' }]
      },
      formInline: {
        page: 1,
        serialNumber: '',
        softwareSerialNumber: '',
        machineName: '',
        belongingText: JSON.parse(localStorage.getItem('userdata'))._source.account !== 'admin' ? JSON.parse(localStorage.getItem('userdata'))._source.belonging : '',
        assignBelongingText: '',
        statusText: '',
        creationTime: '',
        lastOnlineTime: '',
        tel: '',
        version: '',
        rentalTime: '',
        dbName: '',
        serialNumberArr: []
      },
      historyFormInline: {
        page: 1,
        firstName: '',
        lastName: '',
        belonging: JSON.parse(localStorage.getItem('userdata'))._source.account !== 'admin' ? JSON.parse(localStorage.getItem('userdata'))._source.belonging : '',
        mode: '',
        operator: '',
        creationTime: ''
      },
      versionformInline: {
        page: 1
      },
      // 删除部门
      seletedata: {
        ids: ''
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      versionList: [],
      // 分页参数
      pageparm: {
        page: 1,
        size: 10,
        total: 10
      }
    }
  },
  // 注册组件
  components: {
    Pagination,Map
  },
  /**
   * 创建完毕
   */
  created() {
    console.log(JSON.parse(localStorage.getItem('userdata'))._source.account, '@@@@@@@@@@@@@@@@@@@@@')
    if(JSON.parse(localStorage.getItem('userdata'))._source.account !== 'admin'){
      this.formInline.belongingText = JSON.parse(localStorage.getItem('userdata'))._source.belonging
      this.formInline.attribution = JSON.parse(localStorage.getItem('userdata'))._source.belonging
      this.historyFormInline.belonging = JSON.parse(localStorage.getItem('userdata'))._source.belonging
    }
    console.log(this.formInline);
    this.formInline.dbName = this.childMsg.dbName
    if(this.childMsg.dbName === 'machine' ||this.childMsg.dbName === 'alarm' || this.childMsg.dbName === 'patient'){
      var obj = {
        page: 1,
        dbName: 'beautycenter',
        fromName: 'machine',
        companyName: '',
        editTime: '',
        editUser: ''
      }
      if(JSON.parse(localStorage.getItem('userdata'))._source.account !== 'admin'){
        obj = {
          page: 1,
          dbName: 'beautycenter',
          fromName: 'machine',
          companyName: JSON.parse(localStorage.getItem('userdata'))._source.belonging,
          editTime: '',
          editUser: ''
        }
      }
      userList(obj)
        .then(res => {
          if(res.code === 201){
            this.belongingOptions = res.data;
          }
        })
        .catch(err => {
        })
    }
    this.getdata(this.formInline)
  },
  mounted(){
     this.timer = setInterval(() => {
         setTimeout(()=>{
           if(JSON.parse(localStorage.getItem('userdata'))._source.account !== 'admin'){
             this.formInline.belongingText = JSON.parse(localStorage.getItem('userdata'))._source.belonging
           }
           if(this.childMsg.dbName === 'machine' ||this.childMsg.dbName === 'alarm' || this.childMsg.dbName === 'patient'){
             var obj = {
              page: 1,
              dbName: 'beautycenter',
              fromName: 'machine',
              companyName: '',
              editTime: '',
              editUser: ''
             }
             userList(obj)
               .then(res => {
                 if(res.code === 201){
                   this.belongingOptions = res.data;
                 }
               })
               .catch(err => {
               })
           }
           this.formInline.dbName = this.childMsg.dbName;
           this.formInline.serialNumber = '';
           this.formInline.machineName = '';
           this.formInline.softwareSerialNumber = '';
           this.formInline.statusText = '';
           this.formInline.creationTime = '';
           this.formInline.lastOnlineTime = '';
           this.formInline.rentalTime = '';
           this.getdata(this.formInline)

           this.editFormVisible = false;
           this.loading= false;
           this.editFormVisible= false;
           this.historyFormVisible= false;
           this.userFormVisible= false;
           this.parametersFormVisible= false;
           this.mapFormVisible= false;
           this.updateFormVisible= false;
           console.log('fuck');
           console.log(this.formInline);
         }, 0)
     }, 1000*30)
  },
  methods: {
    addPlan(){
      this.showPlan = !this.showPlan;
    },
    // 获取设备列表
    getdata(parameter) {
      this.loading = true
      this.pageparm.page = this.formInline.page
      // 请求数据列表
      dataList(parameter)
        .then(res => {
          this.loading = false
          if (res.code === 201) {
            this.listData = res.data;
            this.pageparm.page = res.page;
            this.pageparm.total = res.total;
          } else {
            this.listData = res.data
            // 分页赋值
            this.pageparm.page = this.formInline.page;
            this.pageparm.size = this.formInline.limit;
            this.pageparm.total = res.total;
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('Menu failed to load, please try again laters！')
        })
      getVersion(this.versionformInline)
       .then(res => {
         if(res.code === 201){
           this.versionList = res.data;
         }
       })
       .catch(err => {
         this.$message.error('Version obtaining failed！')
       })
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.getdata(this.formInline)
    },
    // 搜索事件
    search() {
      if(JSON.parse(localStorage.getItem('userdata'))._source.account !== 'admin'){
        this.formInline.belongingText = JSON.parse(localStorage.getItem('userdata'))._source.belonging
        this.formInline.attribution = JSON.parse(localStorage.getItem('userdata'))._source.belonging
        this.historyFormInline.belonging = JSON.parse(localStorage.getItem('userdata'))._source.belonging
      }
      this.getdata(this.formInline)
    },
    //显示编辑界面
    handleClose(done) {
      if (this.loading) {
        return;
      }
      this.$confirm('Are you sure you want to submit the form？')
        .then(_ => {
          if(this.title === 'Add Machine'){
            var date = new Date(this.formInline.rentalTime)
            date = String(date).split('+')[0]

            var myDate = new Date();
            var hour = myDate.getHours();
            myDate.setHours(hour + 2)
            var time = myDate.toISOString()

            this.loading = true;
            this.editForm.attribution = this.formInline.belongingText;
            this.editForm.softwareSerialNumber = this.formInline.softwareSerialNumber;
            this.editForm.rentalTime = new Date(date).toISOString();
            this.editForm.adminpw = '';
            this.editForm.serialNumber = this.formInline.serialNumber;;
            this.editForm.mac = '';
            this.editForm.status = '';
            this.editForm.creationTime = time;
            this.editForm.totalShots = '';
            this.editForm.handleCnt = '';
            this.editForm.preliminary = '';
            this.editForm.rentalCode = '';
            this.editForm.ip = '';
            this.editForm.machineName = '';
            this.editForm.lon = '';
            this.editForm.lat = '';
            this.editForm.expiredDate = '';
            this.editForm.lastOnlineTime = time;
            this.editForm.version = '';
            this.editForm.handleNum = '';
            saveMachine(this.editForm)
              .then(res => {
                this.editFormVisible = false
                this.loading = false
                if (res.code === 201) {
                  console.log(this.editForm);
                  var MachineObj = {
                    page: 1,
                    serialNumber: '',
                    machineName: '',
                    belonging: this.formInline.belongingText,
                    attribution: this.formInline.belongingText,
                    softwareSerialNumber: '',
                    statusText: '',
                    creationTime: '',
                    lastOnlineTime: '',
                    tel: '',
                    version: '',
                    status: '',
                    rentalTime: '',
                    dbName: '',
                    serialNumberArr: []
                  }
                  getMachineData(MachineObj)
                    .then(res => {
                      if(res.code === 201){
                        var beautyCenterObj = {
                          companyName : this.formInline.belongingText
                        }
                        console.log(beautyCenterObj);
                        var total = res.total;
                        getbeautyCenter(beautyCenterObj)
                          .then(res => {
                            if(res.code === 201){
                              var updateObj = {
                                updateId : res.selectId,
                                total : total
                              }
                              updatebeautyCenter(updateObj)
                                .then(res => {
                                  if(res.code === 201){
                                    this.$message({
                                      type: 'success',
                                      message: 'Data saved successfully！'
                                    })
                                    this.timer = setTimeout(() => {
                                      done();
                                      setTimeout(() => {
                                        if(JSON.parse(localStorage.getItem('userdata'))._source.account !== 'admin'){
                                          this.formInline.belongingText = JSON.parse(localStorage.getItem('userdata'))._source.belonging
                                        }else{
                                          this.formInline.belongingText = '';
                                        }
                                        this.getdata(this.formInline)
                                        this.formInline.serialNumber = '';
                                        // this.formInline.belongingText = '';
                                        this.formInline.rentalTime = '';
                                        this.loading = false;

                                      }, 400);
                                    }, 2000);

                                  }
                                })
                            }
                          })
                      }
                    })


                }
              })
              .catch(err => {
                this.editFormVisible = false
                this.loading = false
                this.$message.error('Data saving failed, please try again later！')
              })
          }else{
            var date = new Date(this.formInline.rentalTime)
            date = String(date).split('+')[0]
            this.loading = true;
            this.editForm.belonging = this.formInline.belongingText;
            this.editForm.machineName = this.formInline.machineName;
            this.editForm.softwareSerialNumber = this.softwareSerialNumber;
            this.editForm.rentalTime = new Date(date).toISOString();
            localStorage.setItem('softwareSerialNumber', this.softwareSerialNumber);
            deptSave(this.editForm)
              .then(res => {
                this.editFormVisible = false
                this.loading = false
                if (res.code === 201) {
                  console.log(this.editForm);
                  var MachineObj = {
                    page: 1,
                    serialNumber: '',
                    machineName: '',
                    belonging: this.formInline.belongingText,
                    attribution: this.formInline.belongingText,
                    softwareSerialNumber: '',
                    statusText: '',
                    creationTime: '',
                    lastOnlineTime: '',
                    tel: '',
                    version: '',
                    status: '',
                    rentalTime: '',
                    dbName: '',
                    serialNumberArr: []
                  }
                  getMachineData(MachineObj)
                    .then(res => {
                      if(res.code === 201){
                        var beautyCenterObj = {
                          companyName : this.formInline.belongingText
                        }
                        console.log(beautyCenterObj);
                        var total = res.total;
                        getbeautyCenter(beautyCenterObj)
                          .then(res => {
                            if(res.code === 201){
                              var updateObj = {
                                updateId : res.selectId,
                                total : total
                              }
                              updatebeautyCenter(updateObj)
                                .then(res => {
                                  if(res.code === 201){
                                    this.$message({
                                      type: 'success',
                                      message: 'Data saved successfully！'
                                    })
                                    this.timer = setTimeout(() => {
                                      done();
                                      setTimeout(() => {
                                        if(JSON.parse(localStorage.getItem('userdata'))._source.account !== 'admin'){
                                          this.formInline.belongingText = JSON.parse(localStorage.getItem('userdata'))._source.belonging
                                        }else{
                                          this.formInline.belongingText = '';
                                        }
                                        this.getdata(this.formInline)
                                        this.formInline.serialNumber = '';
                                        // this.formInline.belongingText = '';
                                        this.formInline.rentalTime = '';
                                        this.formInline.machineName = '';
                                        this.loading = false;

                                      }, 400);
                                    }, 2000);

                                  }
                                })
                            }
                          })
                      }
                    })


                }
              })
              .catch(err => {
                this.editFormVisible = false
                this.loading = false
                this.$message.error('Data saving failed, please try again later！')
              })
          }

        })
        .catch(_ => {
          this.$refs.multipleTable.clearSelection();
          this.timer = setTimeout(() => {
            done();
            // 动画关闭需要一定的时间
            setTimeout(() => {
              this.loading = false;
            }, 400);
          }, 500);
        });
    },
    // 指定编辑页面显示的数据
    handleEdit: function(index, row) {
      this.editFormVisible = true
      if (row != undefined && row != 'undefined') {
        console.log(row.softwareSerialNumber,'@@@@@@@@@############');
        this.title = 'Edit';
        this.dialog = true;
        this.childMsg.serialNumberBool = true;
        this.editForm.serialNumber = row.serialNumber;
        this.editForm.softwareSerialNumber = row.softwareSerialNumber;
        this.editForm.belonging = row.belonging;
        this.editForm.attribution = row.belonging;
        this.editForm.machineName = row.machineName;
        this.editForm.rentalTime = row.rentalTime;
        this.editForm.dbName = this.childMsg.dbName;
        this.editForm.updateId = row.id;
        this.formInline.serialNumber = row.serialNumber;
        this.formInline.belongingText = row.belonging;
        this.formInline.rentalTime = row.rentalTime;
        this.formInline.softwareSerialNumber = row.softwareSerialNumber;
        this.formInline.machineName = row.machineName;
        if(this.childMsg.dbName === 'patient'){
          this.formInline.userName = row.firstName + ' ' + row.lastName;
          this.editForm.userId = row.id;
          this.editForm.belonging = row.belonging;
          this.editForm.attribution = row.belonging;
          this.editForm.dbName = this.childMsg.dbName;
        }
      } else {
        this.title = 'Assign Beauty center'
        this.dialog = true;
        this.childMsg.serialNumberBool = false;
        this.editForm.serialNumber = '';
        this.editForm.belonging = '';
        this.editForm.attribution = '';
        this.editForm.rentalTime = '';
        this.editForm.dbName = this.childMsg.dbName;
        this.editForm.serialNumber = [];
        this.formInline.serialNumber = '';
        this.formInline.rentalTime = '';
        // 获取设备列表的设备号
        if(this.childMsg.dbName === 'machine'){
          for(var i=0;i<this.formInline.serialNumberArr.length;i++){
            this.editForm.serialNumber.push(this.formInline.serialNumberArr[i].serialNumber);
          }
        }
        // 获取患者列表的姓名
        if(this.childMsg.dbName === 'patient'){
          var name = '';
          this.editForm.roleId = [];
          for(var i=0;i<this.formInline.serialNumberArr.length;i++){
            this.editForm.serialNumber.push(this.formInline.serialNumberArr[i].id);
          }
        }
        console.log(this.formInline.serialNumberArr);
      }
    },
    AddMachine(){
      this.editFormVisible = true
      this.title = 'Add Machine'
      this.dialog = true;
      this.childMsg.serialNumberBool = false;
      this.editForm.serialNumber = '';
      this.editForm.softwareSerialNumber = '';
      this.editForm.belonging = '';
      this.editForm.attribution = '';
      this.editForm.rentalTime = '';
      this.editForm.dbName = this.childMsg.dbName;
      this.editForm.serialNumber = [];
      this.formInline.serialNumber = '';
      this.formInline.softwareSerialNumber = '';
      this.formInline.rentalTime = '';
    },
    // 获取表格选中的项
    handleSelectionChange(val) {
      console.log(val);
      this.formInline.serialNumberArr = val;
    },
    // 编辑、增加页面保存方法
    submitForm(editData) {
      this.$refs.drawer.closeDrawer()
    },
    saveVersionData(){
      this.loading = true;
      this.versionEditForm.preliminary = this.versionType;
      updateMachineVersion(this.versionEditForm)
        .then(res => {
          if(res.code === 201){
            this.loading = false;
            this.updateFormVisible = false;
            console.log(res);
          }
        })
        .catch(err => {
          console.log(err);
        })
    },
    // 禁用设备
    deleteUser(index, row) {
      this.$confirm('Whether to disable this device?', 'Prompt', {
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Cancel',
        type: 'warning'
      })
        .then(() => {
          var obj = {}
          console.log(row.status);
          if(row.status === 'disable'){
            obj = {updateId : row.id,status: 'offline'}
          }else{
            obj = {updateId : row.id,status: 'disable'}
          }
          console.log(obj);
          disableMachine(obj)
            .then(res => {
              if (res.code === 201) {
                this.getdata(this.formInline)
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.loading = false
              console.log(err);
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    getHistoryList(parameter) {
      this.loading = true
      getHistory(parameter)
        .then(res => {
          this.loading = false
          if (res.code === 201) {
            this.planList = res.data;
            // 分页赋值
            this.pageparm.page = this.formInline.page;
            this.pageparm.total = res.total;
          } else {
            this.planList = res.data
            // 分页赋值
            this.pageparm.currentPage = this.formInline.page
            this.pageparm.pageSize = this.formInline.limit
            this.pageparm.total = res.count
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('Menu failed to load, please try again later！')
        })
    },
    checkHistory(index, row){
     clearInterval(this.timer);
     this.timer = null;
     this.showMenuBtn = true
      console.log(index,row);
      this.title = 'Treatment Log',
      this.historyFormVisible = true
      this.historyFormInline.firstName = row.firstName
      this.historyFormInline.lastName = row.lastName
      this.historyFormInline.status = '0'
      this.rulesPlanForm = row;
      this.getHistoryList(this.historyFormInline);
    },
    modifyParameters(index, row){
      this.parametersFormVisible = true;
      this.title = 'Parameters Setting';
    },
    // 关闭弹出框
    cancelForm() {
      this.loading = false;
      this.dialog = false;
      this.childMsg.serialNumberBool = false;
      this.formInline.serialNumber = '';
      this.formInline.rentalTime = '';
      clearTimeout(this.timer);
      this.$refs.multipleTable.clearSelection();
    },
    // 删除设备tag
    tagClose(tag) {
      console.log(tag);
      this.formInline.serialNumberArr.splice(tag, 1);
    },
    // 关闭弹出框
    closeDialog() {
      this.historyFormVisible = false;
      this.parametersFormVisible = false;
      this.showPlan = false;
      this.scrollDisabled = false
      this.parametersFormVisible = false
      this.changFormVisible = false
      this.showFrequency = false
      this.fluenceFormVisible = false
      this.frequencyFormVisible = false
      this.pulseFormVisible = false
      this.coolingFormVisible = false
      this.showFluence = false
      this.showPulse = false
      this.showCooling = false
      this.showMenuBtn = true
      this.showHrmMenu = false
      this.showHrsMenu = false
      this.showSrsmMenu = false
      this.showSrmmMenu = false
      this.showHrmSkinMenu = false
      this.showStmMenu = false
      this.pararm_showFluence = false
      this.pararm_showPulse = false
      this.pararm_showFrequency = false
      this.pararm_showCooling = false
      this.active = 0;
    },
    userForm(){
      this.userFormVisible = true;
      this.title = 'Add User';
      this.firstName = '';
      this.lastName = '';
      this.sex = '';
      this.tel = '';
      this.totalCnt = '';
      this.belonging = '';
      this.lastUsedMachine = '';
      this.creationTime = '';
      this.lastTreatmentTime = '';
    },
    checkMap(){
      this.mapFormVisible = true;
    },
    Update(index,row){
      this.updateFormVisible = true;
      this.versionEditForm.updateId = row.id;
      console.log(this.versionEditForm.updateId);
    },
    saveUserEditForm(type){
      var date = new Date();
      var hour = date.getHours();
      date.setHours(hour + 2)
      var time = date.toISOString()
        this.loading = true;

      if(type == 'new'){
        this.userEditForm.belonging = JSON.parse(localStorage.getItem('userdata'))._source.belonging;
        this.userEditForm.creationTime = time;
        this.rulesPlanForm.status = '2';
        this.rulesPlanForm.firstName = this.userEditForm.firstName;
        this.rulesPlanForm.lastName = this.userEditForm.lastName;
        createPatient(this.userEditForm)
          .then(res => {
            if(res.code === 201){
              var obj = {
                page: 1,
                firstName : '',
                lastName : '',
                tel : '',
                belonging : JSON.parse(localStorage.getItem('userdata'))._source.account !== 'admin' ? JSON.parse(localStorage.getItem('userdata'))._source.belonging : '',
                creationTime : '',
                lastTreatmentTime : ''
              }
              if(this.showPlan == false){
                setTimeout(()=>{
                  this.loading = false;
                  this.userFormVisible = false;
                  this.showPlan = false;
                  getPatientData(obj);
                },800)
              }
            }
          })
          .catch(err => {
            this.loading = false;
            this.$message.error('Save failed, please try again later！')
          })
      }

      if(type == 'add'){
        console.log(this.rulesPlanForm,'#####################');
        var date = new Date(this.formInline.rentalTime)
        date = String(date).split('+')[0]

        var myDate = new Date();
        var hour = myDate.getHours();
        myDate.setHours(hour + 2)
        var time = myDate.toISOString()

        this.rulesPlanForm.time = time;
        this.rulesPlanForm.forId = this.rulesPlanForm.id;
        this.rulesPlanForm.mode = this.pararm_mode;
        this.rulesPlanForm.fluence = this.pararm_fluence;
        this.rulesPlanForm.pulse = this.pararm_pulse;
        this.rulesPlanForm.frequency = this.pararm_frequency;
        this.rulesPlanForm.cooling = this.pararm_cooling;
        this.rulesPlanForm.skinType = this.pararm_skinType;
        this.rulesPlanForm.inputting = 'true';
        delete this.rulesPlanForm.id;
        createScheduledSession(this.rulesPlanForm)
          .then(res => {
            if(res.code === 201){
              var obj = {
                page: 1,
                firstName : '',
                lastName : '',
                tel : '',
                status: '0',
                belonging : JSON.parse(localStorage.getItem('userdata'))._source.account !== 'admin' ? JSON.parse(localStorage.getItem('userdata'))._source.belonging : '',
                creationTime : '',
                lastTreatmentTime : ''
              }
              setTimeout(()=>{
                console.log('%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%');
                this.loading = false;
                this.userFormVisible = false;
                this.historyFormVisible = false;
                this.showPlan = false;
                this.scrollDisabled = false,
                this.parametersFormVisible = false,
                this.changFormVisible = false,
                this.showFrequency = false,
                this.fluenceFormVisible = false,
                this.frequencyFormVisible = false,
                this.pulseFormVisible = false,
                this.coolingFormVisible = false,
                this.showFluence = false,
                this.showPulse = false,
                this.showCooling = false,
                this.showMenuBtn = true,
                this.showHrmMenu = false,
                this.showHrsMenu = false,
                this.showSrsmMenu = false,
                this.showSrmmMenu = false,
                this.showHrmSkinMenu = false,
                this.showStmMenu = false,
                this.pararm_showFluence = false,
                this.pararm_showPulse = false,
                this.pararm_showFrequency = false,
                this.pararm_showCooling = false,
                this.pararm_imgsrc = require('../assets/img/zhujiemian.jpg');
                getPatientData(obj);
              },800)
            }
          })
          .catch(err => {
            this.loading = false;
            this.$message.error('Save failed, please try again later！')
          })
      }
      console.log(this.userEditForm);
    },
    deletePatientBtn(index, row){
      deletePatient(row)
        .then(res => {
          if(res.code === 201){
            console.log('123');
            var obj = {
              page: 1,
              firstName : '',
              lastName : '',
              tel : '',
              belonging : JSON.parse(localStorage.getItem('userdata'))._source.account !== 'admin' ? JSON.parse(localStorage.getItem('userdata'))._source.belonging : '',
              creationTime : '',
              lastTreatmentTime : ''
            }
            setTimeout(()=>{
              this.loading = false;
              this.userFormVisible = false;
              getPatientData(obj);
            },800)
          }
        })
        .catch(err => {
          this.loading = false;
          this.$message.error('Save failed, please try again later！')
        })
    },
    // 下一步
    next(v){
      this.active = v;
      this.historyFormInline.status = v;
      this.showMenuBtn = true;
      this.showHrmMenu = false;
      this.showHrsMenu = false;
      this.showSrsmMenu = false;
      this.showSrmmMenu = false;
      this.showStmMenu = false;
      this.showHrmSkinMenu = false;
      this.pararm_imgsrc = require('../assets/img/zhujiemian.jpg');
      if(v != 3){
        this.getHistoryList(this.historyFormInline);
      }
    },
    changContent(parm){
      this.pararm_option = parm;
      if(this.mode !== 'HRM' && parm === 'pulse'){
        this.changFormVisible = true;
        this.pulseFormVisible = true;
        this.fluenceFormVisible = false;
        this.frequencyFormVisible = false;
        this.coolingFormVisible = false;

      }
      if(parm === 'pulse'){
        this.pulseMin = 30;
        this.pulseMax = 300;
      }
      // if(this.mode === 'HRM' && parm === 'fluence'){
          // this.fluenceMin = 5;
          // this.fluenceMax = 12;
          // this.changStep = 1;
        // this.$message.error("此模式无法设置" + parm);
      // }
      if(parm === 'fluence'){
        this.fluenceFormVisible = true;
        this.pulseFormVisible = false;
        this.frequencyFormVisible = false;
        this.coolingFormVisible = false;

        if(this.pararm_pulse == 30){
          this.fluenceMin = 5;
          this.fluenceMax = 12;
          this.changStep = 1;
        }
        if(this.pararm_pulse == 50){
          this.fluenceMin = 5;
          this.fluenceMax = 15;
          this.changStep = 1;
        }
        if(this.pararm_pulse == 80){
          this.pararm_fluence = 6;
          this.fluenceMin = 6;
          this.fluenceMax = 24;
          this.changStep = 2;
        }
        if(this.pararm_pulse == 100){
          this.pararm_fluence = 6;
          this.fluenceMin = 6;
          this.fluenceMax = 28;
          this.changStep = 2;
        }
        if(this.pararm_pulse == 200 || this.pararm_pulse == 300){
          this.pararm_fluence = 10;
          this.fluenceMin = 10;
          this.fluenceMax = 40;
          this.changStep = 2;
        }
      }
      if(this.mode !== 'HRM' && parm === 'cooling'){
        this.coolingFormVisible = true;
        this.pulseFormVisible = false;
        this.fluenceFormVisible = false;
        this.frequencyFormVisible = false;
      }
      if(this.mode !== 'HRM' && parm === 'frequency'){
        this.frequencyFormVisible = true;
        this.pulseFormVisible = false;
        this.fluenceFormVisible = false;
        this.coolingFormVisible = false;
        if(this.pararm_pulse == 30){
          this.frequencyMin = 1;
          this.frequencyMax = 12;
          this.changStep = 1;
        }
        if(this.pararm_pulse == 50){
          this.frequencyMin = 1;
          this.frequencyMax = 8;
          this.changStep = 1;
        }
        if(this.pararm_pulse == 80){
          this.frequencyMin = 1;
          this.frequencyMax = 5;
          this.changStep = 1;
        }
        if(this.pararm_pulse == 100){
          this.frequencyMin = 1;
          this.frequencyMax = 4;
          this.changStep = 1;
        }
        if(this.pararm_pulse == 200){
          this.frequencyMin = 1;
          this.frequencyMax = 2;
          this.changStep = 1;
        }
        if(this.pararm_pulse == 300){
          this.frequencyMin = 1;
          this.frequencyMax = 1;
          this.changStep = 1;
        }
      }
      console.log(parm);
    },
    showStm(){
      this.backClass = 'stmBack';
      this.showMenuBtn = false;
      this.showStmMenu = true;
      this.pararm_imgsrc = require('../assets/img/stm.jpg');
    },
    showHrm(type){
      this.backClass = 'hrmBack';
      this.upClass = 'hrmUp';
      this.downClass = 'hrmDown';
      this.confirmClass = 'hrmConfirm';
      this. pararm_fluenceClass= 'hrm_pararm_fluence';
      this.pararm_mode = 'HRM';
      this.showMenuBtn = false;
      this.showHrmSkinMenu = false;
      this.showHrmMenu = true;
      this.pararm_showFluence = true;
      this.pararm_imgsrc = require('../assets/img/hrm.jpg');
      this.pararm_skinType = type;
      if(type === '1'){
        this.fluenceMin = 5;
        this.fluenceMax = 12;
        this.changStep = 1;
      }
      if(type === '2'){
        this.fluenceMin = 5;
        this.fluenceMax = 11;
        this.changStep = 1;
      }
      if(type === '3'){
        this.fluenceMin = 5;
        this.fluenceMax = 10;
        this.changStep = 1;
      }
      if(type === '4'){
        this.fluenceMin = 5;
        this.fluenceMax = 9;
        this.changStep = 1;
      }
      if(type === '5'){
        this.fluenceMin = 5;
        this.fluenceMax = 8;
        this.changStep = 1;
      }
      if(type === '6'){
        this.fluenceMin = 5;
        this.fluenceMax = 7;
        this.changStep = 1;
      }
    },
    showHrmSkin(){
      this.backClass = 'skinBack'
      this.pararm_mode = 'SKIN';
      this.showMenuBtn = false;
      this.showHrmSkinMenu = true;
      this.pararm_imgsrc = require('../assets/img/hrmskin.jpg');
    },
    showHrs(){
      this.backClass = 'hrsBack'
      this.upClass = 'hrsUp';
      this.downClass = 'hrsDown';
      this.confirmClass = 'hrsConfirm';
      this. pararm_fluenceClass= 'hrs_pararm_fluence';
      this. pararm_pulseClass= 'hrs_pararm_pulse';
      this. pararm_frequencyClass= 'hrs_pararm_frequency';
      this. pararm_coolingClass= 'hrs_pararm_cooling';
      this.pararm_mode = 'HRS';
      this.showMenuBtn = false;
      this.showHrsMenu = true;
      this.pararm_showFluence = true;
      this.pararm_showPulse = true;
      this.pararm_showFrequency = true;
      this.pararm_showCooling = true;
      this.pararm_imgsrc = require('../assets/img/hrs.jpg');
    },
    showSrsm(){
      this.pararm_mode = 'SRSM';
      this.backClass = 'srsmBack'
      this.upClass = 'srsmUp';
      this.downClass = 'srsmDown';
      this.confirmClass = 'srsmConfirm';
      this. pararm_fluenceClass= 'srsm_pararm_fluence';
      this. pararm_pulseClass= 'srsm_pararm_pulse';
      this. pararm_frequencyClass= 'srsm_pararm_frequency';
      this.showMenuBtn = false;
      this.showStmMenu = false;
      this.pararm_showFluence = true;
      this.pararm_showPulse = true;
      this.pararm_showFrequency = true;
      this.showSrsmMenu = true;
      this.pararm_imgsrc = require('../assets/img/srsm.jpg');
    },
    showSrmm(){
      this.pararm_mode = 'SRMM';
      this.backClass = 'srmmBack'
      this.upClass = 'srmmUp';
      this.downClass = 'srmmDown';
      this.confirmClass = 'srmmConfirm';
      this. pararm_fluenceClass= 'srmm_pararm_fluence';
      this. pararm_pulseClass= 'srmm_pararm_pulse';
      this. pararm_frequencyClass= 'srmm_pararm_frequency';
      this.showMenuBtn = false;
      this.showStmMenu = false;
      this.pararm_showFluence = true;
      this.pararm_showPulse = true;
      this.pararm_showFrequency = true;
      this.showSrmmMenu = true;
      this.pararm_imgsrc = require('../assets/img/srmm.jpg');
    },
    up(){
      if(this.pararm_mode === 'HRM'){
        if(this.pararm_fluence < this.fluenceMax){
          this.pararm_fluence = this.pararm_fluence + this.changStep;
        }
        console.log(this.pararm_fluence);
      }
      if(this.pararm_mode === 'HRS'){
        console.log(this.pararm_option);
        if(this.pararm_option === 'pulse'){
          if(this.pararm_pulse < this.pulseMax){
            if(this.pararm_pulse == 30 || this.pararm_pulse == 80){
              this.changStep = 20;
            }
            if(this.pararm_pulse == 50){
              this.changStep = 30;
            }
            if(this.pararm_pulse >= 100){
              this.changStep = 100;
            }
            this.pararm_pulse = this.pararm_pulse + this.changStep;
          }
        }
        if(this.pararm_option === 'fluence'){
          console.log(this.pararm_fluence);
          if(Number(this.pararm_fluence) < this.fluenceMax){
            this.pararm_fluence = this.pararm_fluence + this.changStep;
          }
        }
        if(this.pararm_option === 'frequency'){
          console.log(this.pararm_frequency);
          if(this.pararm_frequency < this.frequencyMax){
            this.pararm_frequency = this.pararm_frequency + this.changStep;
          }
        }
        if(this.pararm_option === 'cooling'){
          console.log(this.pararm_cooling);
          if(this.pararm_cooling < 5){
            this.pararm_cooling = this.pararm_cooling + 1;
          }
        }
      }
      if(this.pararm_mode === 'SRSM' || this.pararm_mode === 'SRMM'){
        console.log(this.pulseMax);
        if(this.pararm_option === 'pulse'){
          if(this.pararm_pulse < this.pulseMax){
            if(this.pararm_pulse == 30 || this.pararm_pulse == 80){
              this.changStep = 20;
            }
            if(this.pararm_pulse == 50){
              this.changStep = 30;
            }
            if(this.pararm_pulse >= 100){
              this.changStep = 100;
            }
            this.pararm_pulse = this.pararm_pulse + this.changStep;
          }
        }
        if(this.pararm_option === 'fluence'){
          if(this.pararm_fluence < this.fluenceMax){
            this.pararm_fluence = this.pararm_fluence + this.changStep;
          }
          console.log(this.pararm_fluence);
        }
        if(this.pararm_option === 'frequency'){
          console.log(this.pararm_frequency);
          if(this.pararm_frequency < this.frequencyMax){
            this.pararm_frequency = this.pararm_frequency + this.changStep;
          }
        }
      }
    },
    down(){
      if(this.pararm_mode === 'HRM'){
        if(this.pararm_fluence > this.fluenceMin){
          this.pararm_fluence = this.pararm_fluence - this.changStep;
        }
        console.log(this.pararm_fluence);
      }
      if(this.pararm_mode === 'HRS'){
        if(this.pararm_option === 'pulse'){
          if(this.pararm_pulse > this.pulseMin){
            if(this.pararm_pulse == 80){
              this.changStep = 30;
            }
            if(this.pararm_pulse == 50){
              this.changStep = 20;
            }
            if(this.pararm_pulse == 100){
              this.changStep = 20;
            }
            if(this.pararm_pulse > 100){
              this.changStep = 100;
            }
            this.pararm_pulse = this.pararm_pulse - this.changStep;
          }
        }
        if(this.pararm_option === 'fluence'){
          if(this.pararm_fluence > this.fluenceMin){
            this.pararm_fluence = this.pararm_fluence - this.changStep;
          }
          console.log(this.pararm_fluence);
        }
        if(this.pararm_option === 'frequency'){
          console.log(this.pararm_frequency);
          if(this.pararm_frequency > this.frequencyMin){
            this.pararm_frequency = this.pararm_frequency - this.changStep;
          }
        }
        if(this.pararm_option === 'cooling'){
          console.log(this.pararm_cooling);
          if(this.pararm_cooling > 0){
            this.pararm_cooling = this.pararm_cooling - 1;
          }
        }
      }
      if(this.pararm_mode === 'SRSM' || this.pararm_mode === 'SRMM'){
        if(this.pararm_option === 'pulse'){
          if(this.pararm_pulse > this.pulseMin){
            if(this.pararm_pulse == 80){
              this.changStep = 30;
            }
            if(this.pararm_pulse == 50){
              this.changStep = 20;
            }
            if(this.pararm_pulse == 100){
              this.changStep = 20;
            }
            if(this.pararm_pulse > 100){
              this.changStep = 100;
            }
            this.pararm_pulse = this.pararm_pulse - this.changStep;
          }
        }
        if(this.pararm_option === 'fluence'){
          if(this.pararm_fluence > this.fluenceMin){
            this.pararm_fluence = this.pararm_fluence - this.changStep;
          }
          console.log(this.pararm_fluence);
        }
        if(this.pararm_option === 'frequency'){
          console.log(this.pararm_frequency);
          if(this.pararm_frequency > this.frequencyMin){
            this.pararm_frequency = this.pararm_frequency - this.changStep;
          }
        }
      }
    },
    back(parm){
      if(parm === 'HRM'){
        this.backClass = 'skinBack';
        this.showHrmMenu = false;
        this.pararm_showFluence = false;
        this.showHrmSkinMenu = true;
        this.pararm_imgsrc = require('../assets/img/hrmskin.jpg');
      }
      if(parm === 'SKIN'){
        this.showHrmMenu = false;
        this.pararm_showFluence = false;
        this.showHrmSkinMenu = false;
        this.showMenuBtn = true;
        this.pararm_imgsrc = require('../assets/img/zhujiemian.jpg');
      }
      if(parm === 'HRS'){
        this.showHrmMenu = false;
        this.pararm_showFluence = false;
        this.pararm_showPulse = false;
        this.pararm_showFrequency= false;
        this.pararm_showCooling = false;
        this.showHrsMenu = false;
        this.showMenuBtn = true;
        this.pararm_imgsrc = require('../assets/img/zhujiemian.jpg');
      }
      if(parm === 'STM'){
        this.showHrmMenu = false;
        this.pararm_showFluence = false;
        this.pararm_showPulse = false;
        this.pararm_showFrequency= false;
        this.pararm_showCooling = false;
        this.showHrsMenu = false;
        this.showStmMenu = false;
        this.showMenuBtn = true;
        this.pararm_imgsrc = require('../assets/img/zhujiemian.jpg');
      }
      if(parm === 'SRSM'){
        this.backClass = 'stmBack';
        this.showHrmMenu = false;
        this.pararm_showFluence = false;
        this.pararm_showPulse = false;
        this.pararm_showFrequency= false;
        this.pararm_showCooling = false;
        this.showHrsMenu = false;
        this.showStmMenu = true;
        this.showSrsmMenu = false
        this.showMenuBtn = true;
        this.pararm_imgsrc = require('../assets/img/stm.jpg');
      }
      if(parm === 'SRMM'){
        this.backClass = 'stmBack';
        this.showHrmMenu = false;
        this.pararm_showFluence = false;
        this.pararm_showPulse = false;
        this.pararm_showFrequency= false;
        this.pararm_showCooling = false;
        this.showHrsMenu = false;
        this.showStmMenu = true;
        this.showSrmmMenu = false
        this.showMenuBtn = true;
        this.pararm_imgsrc = require('../assets/img/stm.jpg');
      }
    },
    clickType(type,e){
      this.pararm_skinType = type;
      e.target.style.border = "2px solid skyblue";
    },
  saveChang(){
    var date = new Date();
    var hour = date.getHours();
    date.setHours(hour + 2)
    var time = date.toISOString()
    this.loading = true;
    this.rulesPlanForm.mode = this.pararm_mode;
    this.rulesPlanForm.fluence = this.pararm_fluence;
    this.rulesPlanForm.pulse = this.pararm_pulse;
    this.rulesPlanForm.frequency = this.pararm_frequency;
    this.rulesPlanForm.cooling = this.pararm_cooling;
    this.rulesPlanForm.skinType = this.pararm_skinType;
    this.rulesPlanForm.inputting = 'true';
    this.rulesPlanForm.date = time;
    console.log(this.rulesPlanForm);
  },
  },
  beforeDestroy(){
     clearInterval(this.timer);
     this.timer = null;
  }
}
</script>

<style scoped>
#userFormVisible .el-input{
  width: 260px;
}
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
.serialnNmber-tag{
  width: 82%;
  min-height: 60px;
  border: 1px solid #DCDFE6;
  border-radius: 4px;
}
.el-drawer__body>* {
  box-sizing: border-box;
}
.el-tag.el-tag--info{
  margin-left: 10px;
}
.demo-drawer__content {
  display: flex;
  flex-direction: column;
  padding: 20px;
  height: 100%;
}
.demo-drawer__footer{
  display: flex;
}
.demo-drawer__content form{
  flex: 1;
}
.demo-drawer__footer button{
  flex: 1;
}

.add_plan{
  position: absolute;
  top: 1.25rem;
  left: 6.25rem;
}
  .menu_btn{
    position: absolute;
    bottom: 18%;
    left: 0;
    right: 0;
  }
  .hrm_btn,.hrs_btn,.stm_btn{
    display: inline-block;
    width: 140px;
    height: 54px;
    cursor: pointer;
    /* border: 2px solid #1F2D3D; */
  }
  .hrm_btn{
    margin-left: 6%;
  }
  .hrs_btn{
    margin-left: 4%;
  }
  .stm_btn{
    margin-left: 3%;
  }
  .hrmUp,.hrsUp,.srsmUp,.srmmUp,.hrmDown,.hrsDown,.srsmDown,.srmmDown,.hrmBack,.skinBack,.hrsBack,.srsmBack,.srmmBack,.hrmConfirm,.hrsConfirm,.srsmConfirm,.srmmConfirm{
    position: absolute;
    width: 100px;
    height: 100px;
    cursor: pointer;
    /* border: 2px solid #1F2D3D; */
  }
  .hrmUp{
    top: 20%;
    left: 5%;
  }
  .hrsUp{
    bottom: 6%;
    left: 5%;
  }
  .srsmUp{
    bottom: 6%;
    left: 4%;
  }
  .srmmUp{
    bottom: 5%;
    left: 4%;
  }
  .hrmDown{
    top: 55%;
    left: 5%;
  }
  .hrsDown{
    bottom: 6%;
    left: 20%;
  }
  .srsmDown{
    bottom: 6%;
    left: 19%;
  }
  .srmmDown{
    bottom: 5%;
    left: 19%;
  }
  .hrmBack{
    bottom: 25%;
    right: 5%;
  }
  .skinBack{
    bottom: -21%;
    right: 19%;
    width: 304px;
    height: 60px;
  }
  .hrsBack{
    bottom: 6%;
    right: 5%;
  }
  .srsmBack{
    bottom: 6%;
    right: 6%;
  }
  .srmmBack{
    bottom: 5%;
    right: 6%;
  }
  .hrmConfirm{
    bottom: 25%;
    right: 21%;
  }
  .hrsConfirm{
    bottom: 6%;
    right: 20%;
  }
  .srsmConfirm{
    bottom: 6%;
    right: 21%;
  }
  .srmmConfirm{
    bottom: 5%;
    right: 21%;
  }
  .hrm_pararm_fluence{
    position: absolute;
    top: -5%;
    left: 23%;
    width: 280px;
    height: 280px;
    text-align: center;
    line-height: 280px;
    font-size: 8rem;
    cursor: pointer;
  }
  .hrmSkin_menu{
    position: absolute;
    top: 9%;
    left: 20%;
    width: 462px;
    font-size: 0;
  }
  .hrmSkin_option{
    display: inline-block;
    margin: 7px 3px;
    width: 140px;
    height: 154px;
    cursor: pointer;
    /* border: 2px solid #1F2D3D; */
  }
  .fluence{
    position: absolute;
    top: 18%;
    left: 16%;
    font-size: 6rem;
  }
  .pulse{
    position: absolute;
    top: 18%;
    left: 46%;
    font-size: 6rem;
  }
  .frequency{
    position: absolute;
    top: 17%;
    left: 76%;
    font-size: 4rem;
  }
  .cooling{
    position: absolute;
    top: 41%;
    left: 76%;
    font-size: 4rem;
  }
  .hrm_fluence{
    position: absolute;
    top: 24%;
    left: 38%;
    font-size: 6rem;
  }
  .srsm_fluence{
    position: absolute;
    top: 15%;
    left: 4%;
    font-size: 6rem;
    width: 200px;
    height: 184px;
    text-align: center;
    line-height: 184px;
  }
  .srmm_fluence{
    position: absolute;
    top: 23%;
    left: 4%;
    font-size: 6rem;
    width: 200px;
    height: 184px;
    text-align: center;
    line-height: 184px;
  }
  .srsm_frequency{
    position: absolute;
    top: 15%;
    left: 35%;
    font-size: 6rem;
    width: 200px;
    height: 184px;
    text-align: center;
    line-height: 184px;
  }
  .srmm_frequency{
    position: absolute;
    top: 23%;
    left: 35%;
    font-size: 6rem;
    width: 200px;
    height: 184px;
    text-align: center;
    line-height: 184px;
  }
  .srsm_pulse{
    position: absolute;
    top: 15%;
    left: 66%;
    font-size: 6rem;
    width: 200px;
    height: 184px;
    text-align: center;
    line-height: 184px;
  }
  .srmm_pulse{
    position: absolute;
    top: 23%;
    left: 66%;
    font-size: 6rem;
    width: 200px;
    height: 184px;
    text-align: center;
    line-height: 184px;
  }
  .hrs_pararm_fluence,.hrs_pararm_pulse{
    position: absolute;
    width: 210px;
    height: 260px;
    font-size: 6rem;
    text-align: center;
    line-height: 260px;
    cursor: pointer;
    /* border: 2px solid #000000; */
  }
  .hrs_pararm_frequency,.hrs_pararm_cooling{
    position: absolute;
    width: 210px;
    height: 122px;
    font-size: 4rem;
    text-align: center;
    line-height: 122px;
    cursor: pointer;
    /* border: 2px solid #000000; */
  }
  .hrs_pararm_fluence{
    top: -5%;
    left: 5%;
  }
  .hrs_pararm_pulse{
    top: -5%;
    left: 36%;
  }
  .hrs_pararm_frequency{
    top: 2%;
    right: 5%;
  }
  .hrs_pararm_cooling{
    top: 29%;
    right: 5%;
  }
  .srsm_menu,.srmm_menu,.stmBack{
    position: absolute;
    width: 134px;
    height: 56px;
    cursor: pointer;
    /* border: 2px solid #1F2D3D; */
  }
  .srsm_menu{
    bottom: 18%;
    left: 6%;
  }
  .srmm_menu{
    bottom: 18%;
    left: 29%;
  }
  .stmBack{
    bottom: 18%;
    right: 6%;
  }
  .srsm_pararm_fluence,.srsm_pararm_pulse,.srsm_pararm_frequency,.srmm_pararm_fluence,.srmm_pararm_pulse,.srmm_pararm_frequency{
    position: absolute;
    width: 210px;
    height: 190px;
    text-align: center;
    line-height: 190px;
    font-size: 6rem;
    cursor: pointer;
    /* border: 2px solid #000000; */
  }

  .srsm_pararm_fluence,.srmm_pararm_fluence{
    top: 15%;
    left: 4%;
  }
  .srsm_pararm_pulse,.srmm_pararm_pulse{
    top: 15%;
    left: 65%;
  }
  .srsm_pararm_frequency,.srmm_pararm_frequency{
    top: 15%;
    left: 35%;
  }
  .srmm_pararm_fluence,.srmm_pararm_pulse,.srmm_pararm_frequency{
    top: 24%;
  }

  .srsm_skinType{
    position: absolute;
    top: 17%;
    left: 4%;
    width: 666px;
    height: 70px;
  }
  .srmm_skinType{
    position: absolute;
    top: 25%;
    left: 4%;
    width: 666px;
    height: 70px;
  }
  .type1,.type2,.type3,.type4,.type5,.type6{
    float: right;
    width: 52px;
    height: 52px;
    margin-top: 8px;
    border: 2px solid #fff;
    cursor: pointer;
  }
  .type6{
    margin-right: 15px;
  }
  .type1,.type4,.type5{
    margin-right: 19px;
  }
  .type2,.type3{
    margin-right: 20px;
  }

  .el-dialog__body{
    padding: 50px 20px;
  }
  .demo-drawer__footer{
    position: absolute;
    bottom: 1%;
    right: 2%;
  }
  #radio-title{
    margin: 10px 0 10px 14px;
  }
  .wrap-li{
    padding: 10px;
    height: 20px;
    line-height: 20px;
  }
  #realTime-bg{
    position: relative;
    width: 100%;
  }
  #changNum{
    position: absolute;
    bottom: 4%;
    left: 50%;
    transform: translateX(-50%);
  }
  #content-wrap{
    height: 384px;
  }
  .infinite-list{
    height: 378px;
    max-height: 378px;
    background-color: #FAFAFA;
  }
  .skinType-wrap{
    position: absolute;
    left: 50%;
    width: 270px;
    transform: translateX(-50%);
  }
  .title{
    float: left;
  }
  .el-radio-button__inner{
    background: #000;
  }
  .message{
    float: right;
  }
  .card-title {
    font-size: 16px;
    font-weight: 500;
    margin-top: 0;
    margin-bottom: 30px;
    text-transform: capitalize;
    color: #222e37;
  }
  .user .content{
    float: left;
    max-width: 240px;
    padding: 6px;
    line-height: 20px;
    border: 1px solid #ccc;
    border-radius: 10px;
    text-align: left;
    word-break:break-all;
    background-color: rgba(0,255,0,.1);
  }
  .myself .content{
    float: right;
    max-width: 240px;
    padding: 6px;
    line-height: 20px;
    border: 1px solid #ccc;
    border-radius: 10px;
    text-align: left;
    word-break:break-all;
    background-color: rgba(0,255,0,.1);
  }
  .user .name{
    display: block;
    padding: 0 4px 0 4px;
    text-align: left;
  }
  .myself .name{
    display: block;
    padding: 0 4px 0 4px;
    text-align: right;
  }
  #email-wrap{
  	position: absolute;
  	top: 0;
  	left: 50%;
    width: 50%;
    height: 350px;
  	transform: translateX(-50%);
  }
  .email-left,.email-right{
  	float: left;
  	display: flex;
  	flex: 1;
    text-align: center;
  }
  .email-left{
    position: absolute;
    top: 18%;
    left: 50%;
    transform: translateX(-50%);
  }
  .email-right{
    position: absolute;
    bottom: -30px;
    left: 50%;
    transform: translateX(-50%);
  }
  .equipment-left,.equipment-right{
  	width: 160px;
  	height: 210px;
  	margin: 0 10px 0 10px;
  	border: 1px solid #999;
  	border-radius: 4px;
  	background-color: rgba(212,246,245,0.9);
    box-shadow: 1px 4px 10px #ccc;
  }
  .equipment-top,.equipment-bottom{
  	width: 160px;
  	height: 100px;
  	margin: 2px 10px 0 10px;
  	border: 1px solid #999;
  	border-radius: 4px;
  	background-color: rgba(212,246,245,0.9);
    box-shadow: 1px 4px 10px #ccc;
  }
  .equipment-left > p{
  	margin: 20px 0
  }
  .equipment-right > p{
  	margin: 20px 0
  }
  .text {
    font-size: 14px;
  }

  .item {
    margin-bottom: 18px;
  }

  .clearfix:before,
  .clearfix:after {
    display: table;
    content: "";
  }
  .clearfix:after {
    clear: both
  }

  .box-card {
    width: 200px;
  }
  .el-header, .el-footer {
    background-color: #B3C0D1;
    color: #333;
    text-align: center;
    line-height: 60px;
  }

  .el-aside {
    background-color: #D3DCE6;
    color: #333;
    text-align: center;
  }

  .el-main {
    background-color: #E9EEF3;
    color: #333;
    text-align: center;
    line-height: 160px;
  }

  body > .el-container {
    margin-bottom: 40px;
  }


  /* 设置滚动条的样式 */
  ::-webkit-scrollbar {
    width:12px;
  }
  /* 滚动槽 */
  ::-webkit-scrollbar-track {
    -webkit-box-shadow:inset006pxrgba(0,0,0,0.3);
    border-radius:10px;
  }
  /* 滚动条滑块 */
  ::-webkit-scrollbar-thumb {
    border-radius:10px;
    background:rgba(0,0,0,0.1);
    -webkit-box-shadow:inset006pxrgba(0,0,0,0.5);
  }
  ::-webkit-scrollbar-thumb:window-inactive {
    background:rgba(0,0,0,0.4);
  }
  .el-container:nth-child(5) .el-aside,
  .el-container:nth-child(6) .el-aside {
    line-height: 260px;
  }

  .el-container:nth-child(7) .el-aside {
    line-height: 320px;
  }
  @media (max-width: 1700px){
    .menu_btn{
      position: absolute;
      bottom: 18%;
      left: 0;
      right: 0;
    }
    .hrm_btn,.hrs_btn,.stm_btn{
      display: inline-block;
      width: 170px;
      height: 70px;
      cursor: pointer;
      /* border: 2px solid #1F2D3D; */
    }
    .hrm_btn{
      margin-left: 6%;
    }
    .hrs_btn{
      margin-left: 2%;
    }
    .stm_btn{
      margin-left: 3%;
    }
    .hrmUp,.hrsUp,.srsmUp,.srmmUp,.hrmDown,.hrsDown,.srsmDown,.srmmDown,.hrmBack,.skinBack,.hrsBack,.srsmBack,.srmmBack,.hrmConfirm,.hrsConfirm,.srsmConfirm,.srmmConfirm{
      position: absolute;
      width: 120px;
      height: 120px;
      cursor: pointer;
      /* border: 2px solid #1F2D3D; */
    }
    .hrmUp{
      top: 20%;
      left: 5%;
    }
    .hrsUp{
      bottom: 6%;
      left: 5%;
    }
    .srsmUp{
      bottom: 6%;
      left: 4%;
    }
    .srmmUp{
      bottom: 5%;
      left: 4%;
    }
    .hrmDown{
      top: 55%;
      left: 5%;
    }
    .hrsDown{
      bottom: 6%;
      left: 20%;
    }
    .srsmDown{
      bottom: 6%;
      left: 19%;
    }
    .srmmDown{
      bottom: 5%;
      left: 19%;
    }
    .hrmBack{
      bottom: 25%;
      right: 5%;
    }
    .skinBack{
      bottom: -21%;
      right: 19%;
      width: 362px;
      height: 70px;
    }
    .hrsBack{
      bottom: 6%;
      right: 5%;
    }
    .srsmBack{
      bottom: 6%;
      right: 6%;
    }
    .srmmBack{
      bottom: 5%;
      right: 6%;
    }
    .hrmConfirm{
      bottom: 25%;
      right: 21%;
    }
    .hrsConfirm{
      bottom: 6%;
      right: 20%;
    }
    .srsmConfirm{
      bottom: 6%;
      right: 21%;
    }
    .srmmConfirm{
      bottom: 5%;
      right: 21%;
    }
    .hrm_pararm_fluence{
      position: absolute;
      top: 6%;
      left: 23%;
      width: 356px;
      height: 356px;
      text-align: center;
      line-height: 280px;
      font-size: 8rem;
      cursor: pointer;
    }
    .hrmSkin_menu{
      position: absolute;
      top: 9%;
      left: 20%;
      width: 572px;
      height: 436px;
      font-size: 0;
    }
    .hrmSkin_option{
      display: inline-block;
      margin: 7px 3px;
      width: 166px;
      height: 184px;
      cursor: pointer;
      /* border: 2px solid #1F2D3D; */
    }
  .hrs_pararm_fluence,.hrs_pararm_pulse{
    position: absolute;
    width: 270px;
    height: 336px;
    font-size: 6rem;
    text-align: center;
    line-height: 260px;
    cursor: pointer;
    /* border: 2px solid #000000; */
  }
  .hrs_pararm_frequency,.hrs_pararm_cooling{
    position: absolute;
    width: 270px;
    height: 158px;
    font-size: 4rem;
    text-align: center;
    line-height: 122px;
    cursor: pointer;
    /* border: 2px solid #000000; */
  }
  .hrs_pararm_fluence{
    top: 4%;
    left: 5%;
  }
  .hrs_pararm_pulse{
    top: 4%;
    left: 36%;
  }
  .hrs_pararm_frequency{
    top: 8%;
    right: 6%;
  }
  .hrs_pararm_cooling{
    top: 36%;
    right: 6%;
  }
  .srsm_menu,.srmm_menu,.stmBack{
    position: absolute;
    width: 134px;
    height: 56px;
    cursor: pointer;
    /* border: 2px solid #1F2D3D; */
  }
  .srsm_menu{
    bottom: 18%;
    left: 6%;
  }
  .srmm_menu{
    bottom: 18%;
    left: 29%;
  }
  .stmBack{
    bottom: 18%;
    right: 6%;
  }
  .srsm_pararm_fluence,.srsm_pararm_pulse,.srsm_pararm_frequency,.srmm_pararm_fluence,.srmm_pararm_pulse,.srmm_pararm_frequency{
    position: absolute;
    width: 268px;
    height: 244px;
    text-align: center;
    line-height: 190px;
    font-size: 6rem;
    cursor: pointer;
    /* border: 2px solid #000000; */
  }

  .srsm_pararm_fluence,.srmm_pararm_fluence{
    top: 24%;
    left: 4%;
  }
  .srsm_pararm_pulse,.srmm_pararm_pulse{
    top: 24%;
    left: 65%;
  }
  .srsm_pararm_frequency,.srmm_pararm_frequency{
    top: 24%;
    left: 35%;
  }
  .srmm_pararm_fluence,.srmm_pararm_pulse,.srmm_pararm_frequency{
    top: 30%;
  }

  .srsm_skinType{
    position: absolute;
    top: 17%;
    left: 4%;
    width: 856px;
    height: 84px;
  }
  .srmm_skinType{
    position: absolute;
    top: 25%;
    left: 4%;
    width: 856px;
    height: 84px;
  }
  .type1,.type2,.type3,.type4,.type5,.type6{
    float: right;
    width: 70px;
    height: 70px;
    margin-top: 10px;
    border: 2px solid #fff;
    cursor: pointer;
  }
    .type6{
      margin-right: 19px;
    }
    .type1,.type4,.type5{
      margin-right: 23px;
    }
    .type2,.type3{
      margin-right: 23px;
    }
    .fluence{
      position: absolute;
      top: 6%;
      left: 5%;
      font-size: 4rem;
      width: 156px;
      height: 192px;
      text-align: center;
      line-height: 192px;
    }
    .pulse{
      position: absolute;
      top: 7%;
      left: 36%;
      font-size: 4rem;
      width: 156px;
      height: 192px;
      text-align: center;
      line-height: 192px;
    }
    .frequency{
      position: absolute;
      top: 13%;
      left: 64%;
      font-size: 3rem;
      width: 156px;
      height: 90px;
      line-height: 90px;
      text-align: center;
    }
    .cooling{
      position: absolute;
      top: 37%;
      left: 64%;
      font-size: 3rem;
      width: 156px;
      height: 90px;
      line-height: 90px;
      text-align: center;
    }
    .hrm_fluence{
      position: absolute;
      top: 24%;
      left: 38%;
      font-size: 4rem;
    }
    .srsm_fluence{
      position: absolute;
      top: 18%;
      left: 4%;
      font-size: 4rem;
      width: 162px;
      height: 142px;
      text-align: center;
      line-height: 142px;
    }
    .srmm_fluence{
      position: absolute;
      top: 27%;
      left: 4%;
      font-size: 4rem;
      width: 162px;
      height: 142px;
      text-align: center;
      line-height: 142px;
    }
    .srsm_frequency{
      position: absolute;
      top: 18%;
      left: 35%;
      font-size: 4rem;
      width: 162px;
      height: 142px;
      text-align: center;
      line-height: 142px;
    }
    .srmm_frequency{
      position: absolute;
      top: 27%;
      left: 35%;
      font-size: 4rem;
      width: 162px;
      height: 142px;
      text-align: center;
      line-height: 142px;
    }
    .srsm_pulse{
      position: absolute;
      top: 18%;
      left: 66%;
      font-size: 4rem;
      width: 162px;
      height: 142px;
      text-align: center;
      line-height: 142px;
    }
    .srmm_pulse{
      position: absolute;
      top: 27%;
      left: 66%;
      font-size: 4rem;
      width: 162px;
      height: 142px;
      text-align: center;
      line-height: 142px;
    }
  }
  @media (max-width: 1400px){
    .menu_btn{
      position: absolute;
      bottom: 18%;
      left: 0;
      right: 0;
    }
    .hrm_btn,.hrs_btn,.stm_btn{
      display: inline-block;
      width: 140px;
      height: 54px;
      cursor: pointer;
      /* border: 2px solid #1F2D3D; */
    }
    .hrm_btn{
      margin-left: 6%;
    }
    .hrs_btn{
      margin-left: 4%;
    }
    .stm_btn{
      margin-left: 3%;
    }
    .hrmUp,.hrsUp,.srsmUp,.srmmUp,.hrmDown,.hrsDown,.srsmDown,.srmmDown,.hrmBack,.skinBack,.hrsBack,.srsmBack,.srmmBack,.hrmConfirm,.hrsConfirm,.srsmConfirm,.srmmConfirm{
      position: absolute;
      width: 100px;
      height: 100px;
      cursor: pointer;
      /* border: 2px solid #1F2D3D; */
    }
    .hrmUp{
      top: 20%;
      left: 5%;
    }
    .hrsUp{
      bottom: 6%;
      left: 5%;
    }
    .srsmUp{
      bottom: 6%;
      left: 4%;
    }
    .srmmUp{
      bottom: 5%;
      left: 4%;
    }
    .hrmDown{
      top: 55%;
      left: 5%;
    }
    .hrsDown{
      bottom: 6%;
      left: 20%;
    }
    .srsmDown{
      bottom: 6%;
      left: 19%;
    }
    .srmmDown{
      bottom: 5%;
      left: 19%;
    }
    .hrmBack{
      bottom: 25%;
      right: 5%;
    }
    .skinBack{
      bottom: -21%;
      right: 19%;
      width: 304px;
      height: 60px;
    }
    .hrsBack{
      bottom: 6%;
      right: 5%;
    }
    .srsmBack{
      bottom: 6%;
      right: 6%;
    }
    .srmmBack{
      bottom: 5%;
      right: 6%;
    }
    .hrmConfirm{
      bottom: 25%;
      right: 21%;
    }
    .hrsConfirm{
      bottom: 6%;
      right: 20%;
    }
    .srsmConfirm{
      bottom: 6%;
      right: 21%;
    }
    .srmmConfirm{
      bottom: 5%;
      right: 21%;
    }
    .hrm_pararm_fluence{
      position: absolute;
      top: -5%;
      left: 23%;
      width: 280px;
      height: 280px;
      text-align: center;
      line-height: 280px;
      font-size: 8rem;
      cursor: pointer;
    }
    .hrmSkin_menu{
      position: absolute;
      top: 9%;
      left: 20%;
      width: 466px;
      height: 356px;
      font-size: 0;
    }
    .hrmSkin_option{
      display: inline-block;
      margin: 7px 3px;
      width: 146px;
      height: 162px;
      cursor: pointer;
      /* border: 2px solid #1F2D3D; */
    }
  .hrs_pararm_fluence,.hrs_pararm_pulse{
    position: absolute;
    width: 210px;
    height: 260px;
    font-size: 6rem;
    text-align: center;
    line-height: 260px;
    cursor: pointer;
    /* border: 2px solid #000000; */
  }
  .hrs_pararm_frequency,.hrs_pararm_cooling{
    position: absolute;
    width: 210px;
    height: 122px;
    font-size: 4rem;
    text-align: center;
    line-height: 122px;
    cursor: pointer;
    /* border: 2px solid #000000; */
  }
  .hrs_pararm_fluence{
    top: -5%;
    left: 5%;
  }
  .hrs_pararm_pulse{
    top: -5%;
    left: 36%;
  }
  .hrs_pararm_frequency{
    top: 2%;
    right: 5%;
  }
  .hrs_pararm_cooling{
    top: 29%;
    right: 5%;
  }
  .srsm_menu,.srmm_menu,.stmBack{
    position: absolute;
    width: 134px;
    height: 56px;
    cursor: pointer;
    /* border: 2px solid #1F2D3D; */
  }
  .srsm_menu{
    bottom: 18%;
    left: 6%;
  }
  .srmm_menu{
    bottom: 18%;
    left: 29%;
  }
  .stmBack{
    bottom: 18%;
    right: 6%;
  }
  .srsm_pararm_fluence,.srsm_pararm_pulse,.srsm_pararm_frequency,.srmm_pararm_fluence,.srmm_pararm_pulse,.srmm_pararm_frequency{
    position: absolute;
    width: 210px;
    height: 190px;
    text-align: center;
    line-height: 190px;
    font-size: 6rem;
    cursor: pointer;
    /* border: 2px solid #000000; */
  }

  .srsm_pararm_fluence,.srmm_pararm_fluence{
    top: 15%;
    left: 4%;
  }
  .srsm_pararm_pulse,.srmm_pararm_pulse{
    top: 15%;
    left: 65%;
  }
  .srsm_pararm_frequency,.srmm_pararm_frequency{
    top: 15%;
    left: 35%;
  }
  .srmm_pararm_fluence,.srmm_pararm_pulse,.srmm_pararm_frequency{
    top: 24%;
  }

  .srsm_skinType{
    position: absolute;
    top: 17%;
    left: 4%;
    width: 666px;
    height: 70px;
  }
  .srmm_skinType{
    position: absolute;
    top: 25%;
    left: 4%;
    width: 666px;
    height: 70px;
  }
    .type6{
      margin-right: -12px;
    }
    .type1,.type4,.type5{
      margin-right: 23px;
    }
    .type2,.type3{
      margin-right: 22px;
    }
    .fluence{
      position: absolute;
      top: -2%;
      left: 5%;
      font-size: 4rem;
      width: 134px;
      height: 166px;
      text-align: center;
      line-height: 166px;
    }
    .pulse{
      position: absolute;
      top: -2%;
      left: 36%;
      font-size: 4rem;
      width: 134px;
      height: 166px;
      text-align: center;
      line-height: 166px;
    }
    .frequency{
      position: absolute;
      top: 4%;
      left: 65%;
      font-size: 3rem;
      width: 134px;
      height: 78px;
      line-height: 78px;
      text-align: center;
    }
    .cooling{
      position: absolute;
      top: 30%;
      left: 66%;
      font-size: 3rem;
      width: 134px;
      height: 78px;
      line-height: 78px;
      text-align: center;
    }
    .hrm_fluence{
      position: absolute;
      top: 2%;
      left: 24%;
      font-size: 4rem;
      width: 186px;
      height: 186px;
      text-align: center;
      line-height: 186px;
    }
    .srsm_fluence{
      position: absolute;
      top: 15%;
      left: 1%;
      font-size: 4rem;
      width: 162px;
      height: 142px;
      text-align: center;
      line-height: 142px;
    }
    .srmm_fluence{
      position: absolute;
      top: 20%;
      left: 1%;
      font-size: 4rem;
      width: 162px;
      height: 142px;
      text-align: center;
      line-height: 142px;
    }
    .srsm_frequency{
      position: absolute;
      top: 15%;
      left: 32%;
      font-size: 4rem;
      width: 162px;
      height: 142px;
      text-align: center;
      line-height: 142px;
    }
    .srmm_frequency{
      position: absolute;
      top: 20%;
      left: 32%;
      font-size: 4rem;
      width: 162px;
      height: 142px;
      text-align: center;
      line-height: 142px;
    }
    .srsm_pulse{
      position: absolute;
      top: 15%;
      left: 64%;
      font-size: 4rem;
      width: 162px;
      height: 142px;
      text-align: center;
      line-height: 142px;
    }
    .srmm_pulse{
      position: absolute;
      top: 20%;
      left: 64%;
      font-size: 4rem;
      width: 162px;
      height: 142px;
      text-align: center;
      line-height: 142px;
    }
  }
  @media (max-width: 1200px){
    .fluence{
      position: absolute;
      top: 6%;
      left: 5%;
      font-size: 4rem;
      width: 122px;
      height: 148px;
      text-align: center;
      line-height: 148px;
    }
    .pulse{
      position: absolute;
      top: 7%;
      left: 36%;
      font-size: 4rem;
      width: 122px;
      height: 148px;
      text-align: center;
      line-height: 148px;
    }
    .frequency{
      position: absolute;
      top: 13%;
      left: 64%;
      font-size: 3rem;
      width: 122px;
      height: 70px;
      line-height: 70px;
      text-align: center;
    }
    .cooling{
      position: absolute;
      top: 37%;
      left: 64%;
      font-size: 3rem;
      width: 122px;
      height: 70px;
      line-height: 70px;
      text-align: center;
    }
    .hrm_fluence{
      position: absolute;
      top: 24%;
      left: 38%;
      font-size: 4rem;
    }
    .srsm_fluence{
      position: absolute;
      top: 30%;
      left: 14%;
      font-size: 4rem;
    }
    .srsm_frequency{
      position: absolute;
      top: 30%;
      left: 45%;
      font-size: 4rem;
    }
    .srsm_pulse{
      position: absolute;
      top: 30%;
      left: 76%;
      font-size: 4rem;
    }
  }
  @media (min-width: 992px){
    .col-lg-4 {
      margin-right: 10px;
      flex: 0 0 42.333333%;
      max-width: 42.333333%;
    }
    .col-lg-5 {
      margin-right: 10px;
      flex: 0 0 33.333333%;
      max-width: 33.333333%;
    }
  }
  @media (max-width: 992px){
    .myself .name{
      float: right;
      padding: 0 4px 0 4px;
      text-align: right;
      }
    .myself .content{
      float: right;
      width: 240px;
      margin-left: 100px;
      padding: 6px;
      line-height: 20px;
      border: 1px solid #ccc;
      border-radius: 10px;
      text-align: right;
      word-break:break-all;
      background-color: rgba(0,255,0,.1);
    }
  }
  @media (min-width: 992px){
    .col-lg-6 {
      flex: 0 0 22.333333%;
      max-width: 22.333333%;
    }
  }
  @media (max-width: 570px) {
  	#email-wrap{
  		position: absolute;
  		top: 20%;
  		left: 50%;
  		margin-left: -180px;
  	}
  	#email-wrap-top{
  		position: absolute;
  		top: 20%;
  		left: 50%;
  		margin-left: -180px;
  	}
  	.email-left{
  		float: none;
  	}
  	.email-right{
  		float: none;
  		display: flex;
  		flex: 1;
  	}
    .equipment-left,.equipment-right{
      width: 160px;
      height: 210px;
  		margin: 0 10px 0 10px;
      border: 1px solid #999;
      border-radius: 4px;
      background-color: rgba(212,246,245,0.9);
  }
  .equipment-top,.equipment-bottom{
      width: 160px;
      height: 100px;
  		margin: 10px;
      border: 1px solid #999;
      border-radius: 4px;
      background-color: rgba(212,246,245,0.9);
  }
  }
  @media (max-width: 416px) {
  	#email-wrap{
  		position: absolute;
      top: 20%;
      left: 50%;
      margin-left: -114px;
  	}
  	#email-wrap-top{
  		position: absolute;
      top: 20%;
      left: 50%;
      margin-left: -114px;
  	}
  	.email-left{
  		float: none;
  	}
  	.equipment-left > p{
  		margin-top: 0;
  		margin-bottom: 6px;
  		font-size:3rem!important;
  	}
  	.equipment-right > p{
  		margin-top: 0;
  		margin-bottom: 6px;
  		font-size:3rem!important;
  	}
  	.email-right{
  		float: none;
  		display: flex;
  		flex: 1;
  	}
    .equipment-left,.equipment-right{
      width: 107px;
      height: 145px;
      margin: 0 4px 0 4px;
      border: 1px solid #999;
      border-radius: 4px;
      background-color: rgba(212,246,245,0.9);
  	}
  .equipment-top,.equipment-bottom{
      width: 107px;
      height: 100px;
      margin: 4px;
      border: 1px solid #999;
      border-radius: 4px;
      background-color: rgba(212,246,245,0.9);
  }
  }
  .face-color-1{
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
  	background-color: rgb(247,227,220)!important;
  }
  .face-color-2{
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
  	background-color: rgb(255,190,158)!important;
  }
  .face-color-3{
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
  	background-color: rgb(222,176,153)!important;
  }
  .face-color-4{
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
  	background-color: rgb(189,152,133)!important;
  }
  .face-color-5{
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
  	background-color: rgb(118,82,56)!important;
  }
  .face-color-6{
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
  	background-color: rgb(31,25,25)!important;
  }
  .border{
    border: 1px solid #409EFF;
  }
</style>



// WEBPACK FOOTER //
// src/components/dataList.vue